/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "telegram--sprite",
  "use": "telegram--sprite-usage",
  "viewBox": "0 0 30 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 20\" id=\"telegram--sprite\"><path d=\"M28.964 1.094a.215.215 0 0 0-.12-.086h-.003l-.002-.001h-.003v-.001h-.004a.223.223 0 0 0-.093-.001L1.174 6.35a.214.214 0 0 0-.172.176.21.21 0 0 0 .11.217l8.24 4.375 1.174 7.701c.003.02.01.04.019.058l.007.011a.21.21 0 0 0 .038.05l.01.01a.211.211 0 0 0 .05.032c.002.001.006 0 .01.002l.01.006a.216.216 0 0 0 .132.002l.02-.01c.01-.004.022-.007.032-.013l5.728-3.527 5.633 3.526a.219.219 0 0 0 .185.022.213.213 0 0 0 .134-.129l6.452-17.575a.217.217 0 0 0 .008-.023c0-.002 0 0 0 0a.208.208 0 0 0-.03-.167ZM1.844 6.652 27.34 1.707 9.55 10.744 1.843 6.652Zm8.977 11.245-1.037-6.795L26.497 2.61 12.68 12.657c-.01.007-.017.015-.025.023l-.01.01a.209.209 0 0 0-.037.062l-.004.007-1.782 5.138Zm.317.397 1.784-5.144 3.258 2.04-5.042 3.104Zm11.082.174-9.034-5.654L28.341 1.797l-6.122 16.671Z\" fill=\"#fff\" stroke=\"#fff\" stroke-width=\".4\" /></symbol>"
});
sprite.add(symbol);
var viewBoxValues = symbol.viewBox ? symbol.viewBox.split(' ') : []

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox,
      width: viewBoxValues[2],
      height: viewBoxValues[3]
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.width = viewBoxValues[2];
SvgSpriteIcon.height = viewBoxValues[3];
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
